import { Link } from 'react-router-dom';
import { HiArrowUpRight } from 'react-icons/hi2';
import Reveal from '../../../shared/Reveal/Reveal';
import { useHomeMarketsContent } from '../../../../hooks/useHomeMarketsContent';
import './Markets.css';

const Markets = () => {
  const { content, isLoading } = useHomeMarketsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta, posts } = content;
  const titleLines = title.split('\n').filter(Boolean);

  return (
    <section className="markets">
      <div className="markets__inner">
        <div className="markets__grid">
          <Reveal className="markets__intro">
            <h2 className="markets__title">
              {titleLines.map((line, index) => (
                <span key={line}>
                  {line}
                  {index < titleLines.length - 1 ? <br /> : null}
                </span>
              ))}
            </h2>
            <p className="markets__text">{text}</p>
            {cta?.text && cta?.url ? (
              <Link to={cta.url} className="markets__cta">
                {cta.text}
              </Link>
            ) : null}
          </Reveal>

          <div className="markets__posts">
            {posts.map(({ category, title: postTitle, description, to }, index) => (
              <Reveal key={postTitle} delay={index * 90}>
                <Link to={to} className="markets__post">
                  <p className="markets__post-category">{category}</p>
                  <div className="markets__post-head">
                    <h3 className="markets__post-title">{postTitle}</h3>
                    <HiArrowUpRight
                      className="markets__post-arrow"
                      aria-hidden="true"
                    />
                  </div>
                  <p className="markets__post-text">{description}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Markets;
